export default __webpack_public_path__ + "static/5-3a6584f87d1ffb7135805945fba2a9e8.png";